import { useDialogStack } from "@verbleif/lib/src/composables/Dialog/useDialogStack";
import { ref, watch } from "vue";
import UpdateDialog from "../../components/AppUpdate/UpdateDialog.vue";
import { useAppUpdate } from "./useAppUpdate";

export function useAppUpdateDialog() {
  const stack = useDialogStack();
  const { updateAvailable, canDismiss, dismissUpdate } = useAppUpdate();
  const instanceId = ref("");

  watch(updateAvailable, (available) => {
    if (available) {
      if (instanceId.value) {
        return;
      }
      instanceId.value = stack.push({
        id: "app-update",
        component: UpdateDialog,
        priority: "system",
        dismissible: canDismiss.value,
        headless: true,
        paddingless: true,
        size: "small",
        onClose: () => {
          instanceId.value = "";
          if (updateAvailable.value) {
            dismissUpdate();
          }
        },
      });
      return;
    }
    if (instanceId.value) {
      void stack.popAfterSave(instanceId.value);
      instanceId.value = "";
    }
  }, { immediate: true });
}
